@if (groupKey) {
    @switch (groupType) {
        @case (GroupType.TeamGroup) {
            <adapt-link-team [team]="$any(groupKey)"
                             [showIcon]="true"></adapt-link-team>
        }
        @case (GroupType.RoleGroup) {
            <adapt-link-role [role]="$any(groupKey)"
                             [showIcon]="true"></adapt-link-role>
        }
        @case (GroupType.ZoneGroup) {
            <adapt-zone-label [zone]="$any(groupKey)"></adapt-zone-label>
        }
        @default {
            <span>Unknown Type</span>
        }
    }
}
